// extracted by mini-css-extract-plugin
export default {"container":"NoChart_container__e7dXG","content":"NoChart_content__dIX1l","chartTitle":"NoChart_chartTitle__M2Cra","title":"NoChart_title__4Ie2M","subtitle":"NoChart_subtitle__2rOAC"};